export const handleWindow = ()=> {
  const win = typeof window !== 'undefined' ? window : {
    navigator: {
      userAgent: '',
    },
    location: {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      protocol: '',
      search: '',
    },
  }
  return win;
}

export const throttle = (fn, delay) => {
  let valid = true;
  return function () {
    if (!valid) {
      return false;
    }
    valid = false;
    setTimeout(() => {
      fn();
      valid = true;
    }, delay);
    return true;
  };
};
export default {
  throttle,
};
export const getBodySize = () => ({
  width: document.documentElement.clientWidth || document.body.clientWidth,
  height: document.documentElement.clientHeight || document.body.clientHeight,
});

export const setBaseSize = () => {
  const n = document.querySelector('html');
  const defaultWidth = 375;
  const defaultFontSize = 20;
  function t() {
    const w = defaultFontSize * getBodySize().width;
    n.style.fontSize = `${w / defaultWidth}px`;
  }
  t();
  window.onresize = function () {
    t();
  };
};

export const getParamsFromUrl = (key) => {
  const win = handleWindow();
  let { search } = win.location;
  if (search && search !== '') {
    search = search.substr(1);
    const obj = {};
    for (let arr = search.split('&'), i = arr.length - 1; i >= 0; i -= 1) {
      const [searchKey, searchValue] = arr[i].split('=');
      obj[searchKey] = searchValue;
    }
    return key ? obj[key] : obj;
  }
  return null;
};

export const getShareParams = () => {
  const uuid = getParamsFromUrl('uuid') ? getParamsFromUrl('uuid') : undefined;
  const sessionid = getParamsFromUrl('sessionid') ? getParamsFromUrl('sessionid') : undefined;
  const canvas = getParamsFromUrl('canvas') ? getParamsFromUrl('canvas') : undefined;
  return JSON.parse(JSON.stringify({
    type: 'wechat',
    sessionid,
    uuid,
    canvas,
  }));
};

export function hasClass(el, className) {
  if (!el) {
    return false;
  }
  if (el.classList) {
    return Array.prototype.some.call(el.classList, item => (item) === className);
  } else if (el.className) {
    return !!el.className.match(new RegExp(`(\\s|^)${className}(\\s|$)`));
  }
  return false;
}

export function getStyleAttr(obj, attr) {
  return obj.currentStyle ? obj.currentStyle[attr] : getComputedStyle(obj)[attr];
}
